import * as React from "react";
import { useWriteOnlyFirebaseUserState } from "./toucan/src/firebase/hooks";
import { useInterpolatedString } from "./toucan/src/interpolate";
import InterfaceManager from "./toucan/src/interfaces/manager";
import { useTranslation } from "react-i18next";

import { Text, Button, Stack } from "@smartphoneorchestra/components";
import { Screen, TruthAnalyticsLogo } from "./Styles/StyleComponents";

interface GateProps {
  text: string;
  buttonText: string;
  nextInterface: string;
}

const Gate = (props: GateProps) => {
  const { t } = useTranslation("thecircleoftruth");
  const transText = t(props.text);
  const text = useInterpolatedString(transText);
  const nextInterface = useInterpolatedString(props.nextInterface);
  const setInterface = useWriteOnlyFirebaseUserState<string>("interface");

  const onClick = () => {
    if (nextInterface) {
      setInterface(nextInterface);
    }
  };

  React.useEffect(() => {
    InterfaceManager.notifyComponentChanged("gate");
  }, [text]);

  return (
    <Screen align="center" color="blue">
      <TruthAnalyticsLogo width="50%" />
      <Stack grow justify="center">
        <Text center color="primary">
          {text}
        </Text>
        <Button onClick={onClick}>{t(props.buttonText)}</Button>
      </Stack>
    </Screen>
  );
};

export default Gate;
